export default __webpack_public_path__ + "static/media/delete.1b3ddc13.svg";